
import { mapGetters } from "vuex";
import MenuOrderMenuItem from "./menu-order-menu-item.vue";
export default {
  components: { MenuOrderMenuItem },
  props: {
    brandId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      selectedCategory: {},
      search: "",
      isExpanded: false
    };
  },

  mounted() {
    this.selectedCategory = this.getGroupedMenu[0];
    if (this.selectedCategory) {
      this.filteredMenu(this.selectedCategory);
    }
  },
  computed: {
    ...mapGetters("menu", ["getGroupedMenu"]),
    ...mapGetters("order", ["isHomeDelivery"]),
    categoriesWithItems() {
      return this.getGroupedMenu.filter(
        (category) => this.getItemsCount(category) > 0
      );
    }
  },

  methods: {
    toggleExpansion() {
      this.isExpanded = !this.isExpanded;
    },
    selectCategory(category) {
      this.selectedCategory = category;
      this.isExpanded = false;
      this.search = "";
    },
    filterItemsWithValidAddons(items) {
      const filtered = (items || []).filter((item) => {
        if (!item?.item_addons?.items?.length) {
          return true;
        }

        return item.item_addons.items.every((addonGroup) => {
          if (addonGroup.min_selection === 0) return true;

          const activeAddons = addonGroup.addons?.filter(
            (addon) => addon?.item_is_active === 1
          );
          return activeAddons.length >= addonGroup.min_selection;
        });
      });

      return filtered;
    },
    filteredMenu(selectedCategory) {
      const searchTerm = this.search?.trim().toLowerCase();
      const filterItems = (items) =>
        this.filterItemsWithValidAddons(items).filter(
          (item) =>
            item?.restaurant_ids?.includes(+this.brandId) &&
            (!searchTerm || item?.item_name?.toLowerCase().includes(searchTerm))
        );

      const filterSubcategories = (subcategories) =>
        subcategories
          .map((subcategory) => ({
            ...subcategory,
            items: filterItems(subcategory.items)
          }))
          .filter((subcategory) => subcategory?.items?.length > 0);

      const filterCategory = (category) => ({
        ...category,
        items: filterItems(category.items),
        subcategories: category.subcategories
          ? filterSubcategories(category.subcategories)
          : []
      });

      if (selectedCategory) {
        const filteredCategory = filterCategory(selectedCategory);

        if (searchTerm) {
          const categoryArray = this.getGroupedMenu.filter(
            (item) => item.id !== "all-items"
          );

          return categoryArray
            .map(filterCategory)
            .filter(
              (category) =>
                category.items.length > 0 || category.subcategories.length > 0
            );
        }

        return [filteredCategory];
      }

      const categoryArray = this.getGroupedMenu.filter(
        (item) => item.id !== "all-items"
      );

      if (searchTerm) {
        return categoryArray
          .map(filterCategory)
          .filter(
            (category) =>
              category.items.length > 0 || category.subcategories.length > 0
          );
      }

      return categoryArray;
    },
    getItemsCount(category) {
      if (
        category &&
        category.subcategories &&
        category?.subcategories?.length
      ) {
        let count = category?.items?.length;
        category.subcategories.forEach((subcategory) => {
          count +=
            subcategory.items && subcategory.items.length
              ? subcategory.items.length
              : 0;
        });
        return count;
      } else if (category.items && category.items.length) {
        return category.items.length;
      } else {
        return "0";
      }
    }
  }
};
